<template>
  <div class="select container">
    <div class="top">
      <div class="back_box">
        <!-- <img src="@/assets/images/icons/icon_back.png" alt="" /> -->
        <el-button
          class="back-btn"
          type="text"
          icon="el-icon-arrow-left"
          @click="$router.go(-1)"
          >返回</el-button
        >
      </div>
      <div class="info">
        <img class="icon" src="@/assets/images/icons/a_select.png" alt="" />
        <div class="mid">
          <p class="title">{{ info.name }}</p>
          <p style="margin-top: 5px">
            <span class="time">{{
              formatDate(info.startTime, "MM-DD HH:mm")
            }}</span>
            <span class="shu">|</span>
            <span class="surplus" v-if="info.status == 'STARTED'"
              >剩余<i class="el-icon-time"></i>{{ surplus }}分钟</span
            >
            <span class="end_tag" v-else>已结束</span>
          </p>
        </div>
      </div>
    </div>
    <div class="main">
      <p class="no_tips" v-if="list.length <= 0 && info.status == 'STARTED'">
        老师暂未选人!
      </p>
      <template v-else>
        <div class="student" v-for="item in list" :key="item.userId">
          <el-image class="avatar" :src="item.avatar" fit="cover"></el-image>
          <p class="name">{{ item.nickName }}</p>
        </div>
      </template>
    </div>
  </div>
</template>


<script>
import { pickList } from "@/api/activity/pick";
import { activityInfo } from "@/api/activity";
import { formatDate } from "@/utils/index";
import { dateCount } from "@/utils/index";

export default {
  name: "pick",
  data() {
    return {
      formatDate,
      info: {},
      surplus: "",
      list: [],
    };
  },
  created() {
    this.getInfo();
    this.getList();
    this.timer = setInterval(() => {
      if (this.info.status == "STOP") {
        clearInterval(this.timer);
      }
      this.getInfo();
      this.getList();
    }, 3000);
  },
  beforeDestroy() {
    clearInterval(this.timerId);
    clearInterval(this.timer);
  },
  methods: {
    // 活动信息
    getInfo() {
      let activityId = this.$route.query.activityId;
      activityInfo(activityId).then((res) => {
        if (res.code == 0) {
          this.info = res.data;
          let end = new Date(this.info.startTime).getTime();
          let duration = this.info.duration * 60 * 1000;
          end = end + duration;
          let nowTime = +new Date();
          let times = (end - nowTime) / 1000;
          if (times > 0) {
            this.surplus = dateCount(times);
            this.timerId && clearInterval(this.timerId);
            this.timerId = setInterval(() => {
              if (times <= 0  && this.timerId) {
                clearInterval(this.timerId);
                this.getInfo();
              }
              this.surplus = dateCount(times);
              times--;
            }, 1000);
          }
        } else {
          console.log(res.msg);
        }
      });
    },
    // 选中列表
    getList() {
      let activityId = this.$route.query.activityId;
      pickList({ activityId }).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.select {
  height: 100%;
  .top {
    margin-top: 30px;
    margin-bottom: 20px;
    width: 100%;
    text-align: left;
    .back_box {
      display: inline-block;
      width: calc(100% - 1126px);
      text-align: center;
      vertical-align: middle;
      cursor: pointer;
      img {
        width: 44px;
      }
      p {
        color: #969696;
        font-size: 16px;
      }
    }
    .info {
      position: relative;
      display: inline-block;
      padding: 24px 30px;
      background-color: #fff;
      width: 1126px;
      vertical-align: middle;
      .icon {
        width: 44px;
        height: 44px;
      }
      .mid {
        display: inline-block;
        margin-left: 20px;
        vertical-align: middle;
      }
      .title {
        font-size: 16px;
        color: #333;
      }
      .time {
        margin-top: 5px;
        color: #999;
        font-size: 14px;
      }

      .shu {
        padding: 0 10px;
        color: #ddd;
      }
      .el-icon-time {
        margin: 0 5px;
      }
      .surplus {
        color: sandybrown;
      }
      .end_tag {
        color: #c8c8c8;
      }
    }
  }
  .main {
    position: relative;
    padding: 20px 60px;
    height: calc(100% - 30px - 20px - 88px - 30px);
    background-color: #fff;
    // text-align: left;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }

    .no_tips {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 28px;
      color: #c8c8c8;
    }
    .student {
      display: inline-block;
      margin: 20px;
      .avatar {
        width: 130px;
        height: 130px;
        border-radius: 50%;
      }
      .name {
        font-size: 20px;
        color: #333;
      }
    }
  }
}
</style>